import { TToken } from "./index";
import { EARLY_CHILDHOOD_EDUCATION } from "./Onboarding/onboarding-values";

export interface TCreateAdminFormValues {
  candidate_id: number;
  role_id: number | string;
  first_name: string;
  last_name: string;
  phone_number: string;
  email: string;
  timesheet_access: number; // 1 = true, 0 = false
  has_all_centre_access: number; // 1 = true, 0 = false
  centre_ids: Array<number>; // number[]; // Array of centre IDs
}

export type TAdminUser = {
  id: number | null;
  candidate_id: number;
  role_id: number | string;
  first_name: string;
  last_name: string;
  phone_number: string;
  email: string;
  address: string
  centre_ids: Array<number>
  centres: Array<string>
  created_at: string
  has_all_centre_access: number;
  photo: string;
  status: "active" | "inactive"
  timesheet_access: number
  email_verified_at: string;
  uuid: string;
};

// Error Response Type for create/update admin
export type TAdminUserErrorResponse = {
  errors: Partial<Record<keyof TCreateAdminFormValues, string[]>>;
};

export interface IPageLink {
  url: string | null;
  label: string;
  active: boolean;
}

export interface IPaginatedData<T = any> {
  current_page: number;
  data: T[];
  first_page_url: string;
  from: number | null;
  last_page: number;
  last_page_url: string;
  links: IPageLink[];
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  to: number | null;
  total: number;
}

export type TGetAllAdminResponse = {
  status: string;
  message: string;
  data: {
    super_admins: IPaginatedData<TAdminUser>;
    super_admins_total: number;
    general_admins: IPaginatedData<TAdminUser>;
    general_admins_total: number;
    token: TToken;
  };
};

export type TCreateAdminUserResponse = {
  status: string;
  message: string;
  data: {
    id: number;
    uuid: string;
    first_name: string;
    last_name: string;
    full_name: string;
    email: string;
    phone_number: string;
    address: string | null;
    photo: string | null;
    role: string;
    token: TToken;
  };
};

export type TUpdateAdminUserResponse = {
  status: string;
  message: string;
  data: {
    id: number;
    uuid: string;
    first_name: string;
    last_name: string;
    full_name: string;
    email: string;
    phone_number: string;
    address: string | null;
    photo: string | null;
    role: string;
    token: TToken;
  };
};

export interface DocumentConfig {
  type: string;
  title: string;
  isConditional?: boolean;
  conditionField?: string;
  showOnlyForm?: string[];
}

export const DOCUMENT_CONFIGS: DocumentConfig[] = [
  {
    type: 'australian_work_visa',
    title: 'Australian Work Visa',
    showOnlyForm: ["australian_visa_holder"]    
  },
  {
    type: 'permanent_residency_visa',
    title: 'Permanent Residency Visa',
    showOnlyForm: ["australian_permanent_resident"]    
  },
  {
    type: 'working_with_children_check',
    title: 'Working With Children Check / Blue Card',
    isConditional: true,
    conditionField: 'mandatory_reporting_training'
  },
  {
    type: 'first_aid_certificate',
    title: 'First Aid Certificate',
    isConditional: true,
    conditionField: 'first_aid_certificate'
  },
  {
    type: 'mandatory_reporting_training',
    title: 'Mandatory Reporting Training'
  },
  {
    type: 'teachers_registration',
    title: 'Teacher Registration',
    showOnlyForm: ["post_graduate_diploma", "bachelor_or_degree"]    
  },
  {
    type: 'post_graduate_diploma',
    title: 'Post Graduate Diploma',
    showOnlyForm: ["post_graduate_diploma"]
  },
  {
    type: 'bachelor_or_degree',
    title: EARLY_CHILDHOOD_EDUCATION.BACHELOR_OR_DEGREE,
    showOnlyForm: ["bachelor_or_degree"]
  },
   {
    type: 'diploma',
    title: 'Diploma',
    showOnlyForm: ["diploma"]
  },
  {
    type: 'certificate_iii',
    title: EARLY_CHILDHOOD_EDUCATION.CERTIFICATE_III,
    showOnlyForm: ["certificate_iii"]
  },
  {
    type: 'course_progression_letter',
    title: 'Course Progression Letter',
    showOnlyForm: ["currently_studying"]
  },
  {
    type: 'ACECQA_assessment',
    title: 'ACECQA Assessment',
    showOnlyForm: ["acecqa_approved"]
  },
  {
    type: 'cooking_qualification',
    title: 'Cooking Qualification',
    showOnlyForm: ["Chef/Cook"]
  },
  {
    type: 'food_handler_certificate',
    title: 'Food Handler Certificate',
    showOnlyForm: ["Chef/Cook"]
  }
  
];

export const COMPLIANCE_CHECK_DOCUMENT_CONFIGS: DocumentConfig[] = [
  {
    type: 'police_check',
    title: 'Police Check'
  }
];